import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchTermsAndConditions = async () => {
  const response = await axios.get(`${API_BASE_URL}/terms-and-conditions`);
  return response.data;
};

export const uploadTermsAndConditions = async (termsPayload) => {
  const response = await axios.post(
    `${API_BASE_URL}/terms-and-conditions/upload`,
    termsPayload,
    getAuthConfig(),
  );

  return response.data;
};
